import React from 'react';
import './Gallery.css';
import { useLanguage } from './LanguageContext';
import translations from './translations';

function Gallery() {
  const { language } = useLanguage();
  const t = translations[language];
  return (
    <div className="gallery-section">
      <h1 className="gallery-title">{t.galleryTitle}</h1>
      <div className="gallery-grid">
        <img src="/4.png" alt="Fashion 1" />
        <img src="/6.png" alt="Fashion 2" />
        <img src="/7.png" alt="Fashion 3" />
      </div>
    </div>
  );
}

export default Gallery;